module.exports = __webpack_public_path__ + "img/suckerPunch.90110c03.png";